unit uVysledkyTestu;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Buttons, WEBLib.ExtCtrls, Vcl.Controls, WEBLib.REST,
  Vcl.StdCtrls, WEBLib.StdCtrls;

type
  TfVysledkyTestu = class(TForm) // Nastavený na vertikálny ScrollBar
    btnZavriet: TSpeedButton;
    WebPanel1: TPanel;
    WebLabel1: TLabel; // Nastavený na vertikálny ScrollBar
    procedure btnZavrietClick(Sender: TObject);
  private
    FTestID: Integer;
    function VykresliKompletnyPrehlad(const AJSONText: string):string;
  public
  FZoznamChybPrePascal: string;
  Chybne: string;
  [async]
    procedure NacitajVysledky(ATestID: Integer); async;
  protected procedure LoadDFMValues; override; end;

var    fVysledkyTestu:TfVysledkyTestu;

implementation

{$R *.dfm}

uses Hlavny, uStudentTest;

procedure TfVysledkyTestu.NacitajVysledky(ATestID: Integer);
var
  wr: THttpRequest;
  res: TJSXMLHttpRequest;
  // 🚀 FIX 1: Pridaná chýbajúca deklarácia premenných, kompilátor ich už hneď nájde
  CistyJsonText, PayloadText: string;
begin
  FTestID := ATestID;
  PayloadText := '{"TEST_ID":' + IntToStr(FTestID) + '}';
  wr := THttpRequest.Create(nil);
  try
    wr.Command := httpPOST;
    wr.URL := 'http://' + window.location.hostname + ':8080/vytiahnivysledky';
    // 🚀 FIX 2: Vymazané zložené zátvorky {}, zápis funkcie prerobený na jeden riadok
    asm
      var utf8Bytes = encodeURIComponent(PayloadText).replace(/%([0-9A-F]{2})/g, function(match, p1) { return String.fromCharCode('0x' + p1); });
      wr.FPostData = btoa(utf8Bytes);
    end;
    res := await(TJSXMLHttpRequest, wr.Perform);
    // 🛑 1. POISTKA: Ukáže nám stav odpovede (mal by byť 200) a surový text zo servera
{    if res <> nil then
      ShowMessage('STATUS ODPOVEDE: ' + IntToStr(res.status) + sLineBreak +
                  'SUROVÝ BASE64 ZO SERVERA: ' + res.responseText)
    else
      ShowMessage('⚠️ CHYBA: Objek res (odpoveď) je úplne NULL!');}
    if (res <> nil) and (res.responseText <> '') then
    begin
      asm
        var cleanResponse = res.responseText.replace(/[\r\n\s]/g, '');
        var binaryString = atob(cleanResponse);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i++) bytes[i] = binaryString.charCodeAt(i);
        var decoder = new TextDecoder('utf-8');
        CistyJsonText = decoder.decode(bytes);
      end;
      // 🛑 2. POISTKA: Ukáže dešifrovaný text, ak prebehlo atob() úspešne
//      ShowMessage('DEŠIFROVANÝ JSON TEXT: ' + CistyJsonText);
      VykresliKompletnyPrehlad(CistyJsonText);
    end;
  finally
    wr.Free;
  end;
end;

function TfVysledkyTestu.VykresliKompletnyPrehlad(const AJSONText: string):string;
begin
  fZoznamChybPrePascal := ''; // 🚀 A hneď pod begin priradíme prázdny string

//  ShowMessage(AJSONText);

  // Všetko urobíme v jednom súvislom bloku priamo v prehliadači
  asm
    var obj = JSON.parse(AJSONText);
    // 1. Veľká vrchná hlavička s celkovou úspešnosťou testu
    var html = "<div style='font-size: 22px; font-weight: bold; padding: 25px; text-align: center; color: #111; border-bottom: 2px solid #e0e0e0; background-color: #fff; margin-bottom: 20px;'>" +
               "🎯 Výsledok testu: " + obj.ziskane_body + " bodov z " + obj.celkom_otazok + " (Úspešnosť: " + obj.percenta + " %)" +
               "</div>";
    html += "<div style='padding: 10px; font-family: Arial, sans-serif; background-color: #fafafa;'>";
    var otazky = obj.otazky;

    var textChyb = '';
    var pocetChyb = 0;
    for (var i = 0; i < otazky.length; i++)
    {
        var ot = otazky[i];

        // Ak je otázka zle, zapíšeme si jej poradové číslo do dočasného JS textu
        if (ot.bod_zisk === 0) {
            if (textChyb !== "") textChyb += ",";
            textChyb += ot.cislo_otazky.toString();
            pocetChyb++;
                              }


        // Zelený okraj pre získaný bod, červený pre nulu
        var borderStyle = ot.bod_zisk === 1 ? "border-left: 6px solid #28a745;" : "border-left: 6px solid #dc3545;";
        var bgStyle = ot.bod_zisk === 1 ? "background-color: #f8fff9;" : "background-color: #fffafb;";
        html += "<div style='margin-bottom: 25px; padding: 20px; border-radius: 6px; box-shadow: 0 2px 4px rgba(0,0,0,0.06); " + borderStyle + " " + bgStyle + "'>";
        html += "<div style='font-weight: bold; font-size: 16px; margin-bottom: 12px; color: #222;'>" + ot.poradie + ". " + ot.text_otazky + "</div>";
        html += "<div style='margin-left: 15px;'>";
        var odpovede = ot.odpovede;
        for (var j = 0; j < odpovede.length; j++)
        {
            var od = odpovede[j];
            var farbaTextu = "color: #444;";
            var ikona = "⬜ ";
            // Vyhodnocovacia lekárska farebná matematika
            if (od.je_spravna === 1 && od.oznacena_studentom === 1) {
                farbaTextu = "color: #1e7e34; font-weight: bold;";
                ikona = "A  ";
            } else if (od.je_spravna === 0 && od.oznacena_studentom === 1) {
                farbaTextu = "color: #bd2130; font-weight: bold; text-decoration: line-through;";
                ikona = "X  ";
            } else if (od.je_spravna === 1 && od.oznacena_studentom === 0) {
                farbaTextu = "color: #dc3545; font-weight: bold; font-style: italic;";
                ikona = "⚠️ ";
            } else if (od.je_spravna === 0 && od.oznacena_studentom === 0) {
                farbaTextu = "color: #777;";
                ikona = "⬜ ";
            }
            html += "<div style='padding: 6px 0; font-size: 14.5px; line-height: 1.4; " + farbaTextu + "'>" + ikona + od.text_odpovede + "</div>";
        }
        html += "</div>";
        html += "</div>";
    }
    html += "</div>";


    // 🚀 DEFINITÍVNY A NEPRIESTRELNÝ ZÁPIS:
    // Vstrekneme vygenerovaný kód kompletne do elementu tvojho komponentu WebLabel1.
    // Prehliadač to v tejto milisekunde vyrenderuje ako čistú živú grafiku!
    this.WebLabel1.FElement.innerHTML = html;

    this.WebLabel1.FElement.style.overflowY = 'auto';
    this.WebLabel1.FElement.style.maxHeight = '100vh';
    this.WebLabel1.FElement.style.display = 'block';


    this.btnZavriet.SetHint(textChyb);


//    fstudenttest.textChyb := textChyb;
//     fHlavny.FChybneOtazky := textChyb;
//    pas.WebLabel2.caption := textChyb;
//   pas.ustudenttest.fstudentTest.$set('textChyb', textChyb);
//   fZoznamChybPrePascal := textChyb;
//     this.ZoznamChybPrePascal := textChyb;
  end;





end;





procedure TfVysledkyTestu.btnZavrietClick(Sender: TObject);
begin
  ModalResult := mrOk; // Bežné zatvorenie okna, ktoré vráti študenta do hlavného menu
end;





procedure TfVysledkyTestu.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  btnZavriet := TSpeedButton.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  btnZavriet.BeforeLoadDFMValues;
  try
    Name := 'fVysledkyTestu';
    Width := 640;
    Height := 480;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 640;
    WebLabel1.Height := 420;
    WebLabel1.Align := alClient;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 420;
    WebPanel1.Width := 640;
    WebPanel1.Height := 60;
    WebPanel1.Align := alBottom;
    WebPanel1.ChildOrder := 2;
    WebPanel1.TabOrder := 0;
    btnZavriet.SetParentComponent(WebPanel1);
    btnZavriet.Name := 'btnZavriet';
    btnZavriet.Left := 496;
    btnZavriet.Top := 17;
    btnZavriet.Width := 121;
    btnZavriet.Height := 24;
    btnZavriet.Anchors := [akTop,akRight];
    btnZavriet.Caption := 'Zavrie'#357;
    btnZavriet.Color := clNone;
    btnZavriet.HeightPercent := 100.000000000000000000;
    btnZavriet.ShowHint := False;
    btnZavriet.TabOrder := 0;
    btnZavriet.WidthPercent := 100.000000000000000000;
    SetEvent(btnZavriet, Self, 'OnClick', 'btnZavrietClick');
  finally
    WebLabel1.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    btnZavriet.AfterLoadDFMValues;
  end;
end;

end.